<!--Inventory>Transaction(New)-->
<template xmlns="http://www.w3.org/1999/html">
    <div class="mains">
        <!--查询页面-->
        <div v-show="showQuery">
            <a-row>
                <a-button type="primary" size="small" class="mg5" @click="query">{{$t('job.Query')}}</a-button>
                <a-button type="primary" size="small" class="mg5" @click="reset">{{$t('job.Reset')}}</a-button>
                <a-button type="primary" size="small" class="mg5" @click="exportInvTranLog">{{$t('generic.Export')}}</a-button>
            </a-row>
            <a-form :form="formQuery">
                <a-row>
                    <a-col span="24">
                        <el-card class="box-card" style="margin-top: 10px;">
                            <a-row>
                                <a-col :span = "3" offset="0">
                                    <a-form-item  class="genericFrom">
                                        <b>{{$t('invTrans.transType')}}</b>
                                        <a-select size="small" allowClear v-decorator="['type']">
                                            <a-select-option v-for="(item, index) in typeGroup" :key="index" :value="item.CODE">
                                                {{ item.CODE_DESC }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span = "3" offset="1">
                                    <a-form-item class="genericFrom">
                                        <b>{{$t('pubGicSet.LotID')}}</b>
                                        <a-input-search size="small" style="width: 100%;" v-decorator="['lotId']" @search="lotIdSearch"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span = "3" offset="1">
                                    <a-form-item  class="genericFrom">
                                        <b>{{$t('invTrans.orderNo')}}</b>
                                        <a-input size="small" v-decorator="['orderNo']" @pressEnter="query"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="3">
                                    <a-form-item>
                                        <b>{{$t('invTrans.transTimeFrom')}}</b><br>
                                        <a-date-picker size="small" format="YYYY-MM-DD HH:mm" show-time v-decorator="['tranTimeFM']"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="3" offset="1">
                                    <a-form-item>
                                        <b>{{$t('invTrans.transTimeTo')}}</b><br>
                                        <a-date-picker size="small" format="YYYY-MM-DD HH:mm" show-time v-decorator="['tranTimeTO']"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="3" offset="1">
                                    <a-form-item>
                                        <b>{{$t('invTrans.systemUser')}}</b>
                                        <a-input-search size="small" style="width: 100%;" v-decorator="['operator']" @search="operatorSearch"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </el-card>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="11">
                        <el-card class="box-card" style="margin-top: 20px;" :title="$t('easyCron.From')">
                            <a-row style="font-weight: bold;">
                                {{$t('easyCron.From')}}
                            </a-row>
                            <a-row>
                                <a-col :span="6" offset="0">
                                    <a-form-item>
                                        <b>{{$t('batchReceive.SKU')}}</b>
                                        <a-input-search size="small" style="width: 100%;" v-decorator="['skuFrom']" @search="skuFromSearch" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" offset="1">
                                    <a-form-item>
                                        <b>{{$t('pubGicSet.Location')}}</b>
                                        <a-input-search size="small" style="width: 100%;" v-decorator="['locationFrom']" @search="locationFromSearch"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span = "6" offset="1">
                                    <a-form-item  class="genericFrom">
                                        <b>{{$t('invTrans.id')}}</b>
                                        <a-input size="small" v-decorator="['idFrom']" @pressEnter="query"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </el-card>
                    </a-col>
                    <a-col span="11" offset="2">
                        <el-card class="box-card" style="margin-top: 20px;" :title="$t('easyCron.to')">
                            <a-row style="font-weight: bold;">
                                {{$t('easyCron.to')}}
                            </a-row>
                            <a-row>
                                <a-col :span="6" offset="0">
                                    <a-form-item>
                                        <b>{{$t('batchReceive.SKU')}}</b>
                                        <a-input-search size="small" style="width: 100%;" v-decorator="['skuTo']" @search="skuToSearch" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" offset="1">
                                    <a-form-item>
                                        <b>{{$t('pubGicSet.Location')}}</b>
                                        <a-input-search size="small" style="width: 100%;" v-decorator="['locationTo']" @search="locationToSearch"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span = "6" offset="1">
                                    <a-form-item  class="genericFrom">
                                        <b>{{$t('invTrans.id')}}</b>
                                        <a-input size="small" v-decorator="['idTo']" @pressEnter="query"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </el-card>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="24">
                        <el-card class="box-card" style="margin-top: 20px;">
                            <a-row style="font-weight: bold;">
                                {{$t('invTrans.lotAttribute')}}
                            </a-row>
                            <a-row>
                                <a-col :span="2" style="margin-right: 20px;width: 200px;">
                                    <a-form-item>
                                        <b>{{$t('batchReceive.ManufactureDate')}}</b>
                                        <a-date-picker size="small" style="width: 100%" v-decorator="['manufactureDate']"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="2" style="margin-right: 20px;width: 200px;">
                                    <a-form-item>
                                        <b>{{$t('batchReceive.ExpiryDate')}}</b>
                                        <a-date-picker size="small" style="width: 100%" v-decorator="['expiryDate']"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="2" style="margin-right: 20px;width: 200px;">
                                    <a-form-item>
                                        <b>{{$t('batchReceive.RecDate')}}</b>
                                        <a-date-picker size="small" style="width: 100%" v-decorator="['recDate']"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="2" v-for="item in batchAttributes" style="margin-right: 20px;width: 200px;">
                                    <a-form-item>
                                        <b>{{item.udflabel}}</b>
                                        <a-input v-if="item.dataType == 'Text'" size="small" style="width: 100%" v-decorator="[item.uid]"/>
                                        <a-input-number v-if="item.dataType == 'Number'" style="width: 100%" size="small" v-decorator="[item.uid]"/>
                                        <a-date-picker v-if="item.dataType == 'Date'" size="small" style="width: 100%" show-time v-decorator="[item.uid]"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </el-card>
                    </a-col>
                </a-row>
            </a-form>
        </div>

        <!--列表页面-->
        <div v-show="showList">
            <a-row>
                <a-button type="primary" size="small" class="mg5" @click="back">{{$t('invTrans.back')}}</a-button>
                <a-button type="primary" size="small" class="mg5" @click="exportInvTranLog">{{$t('generic.Export')}}</a-button>
            </a-row>
            <el-card class="box-card" style="margin-top: 10px;">
                <a-row>
                    <a-col align="right" style="margin: 0px -7px 5px 0;">
                        <!--分页-->
                        <a-pagination
                                :pageSizeOptions="pageSizeOptions"
                                :showTotal="total => $t('job.Total') + ` ${pagingTotal} `+$t('job.Records')"
                                size="small"
                                :total="pagingTotal"
                                v-model="currentVal"
                                :pageSize.sync="pagingSize"
                                @change="tableChangePage"
                                @showSizeChange="onShowSizeChange"
                                :showSizeChanger="showSizeChanger"
                                :showQuickJumper="showQuickJumper"
                        />
                    </a-col>
                </a-row>
                <a-row>
                    <!--列表-->
                    <vxe-table
                            border
                            resizable
                            stripe
                            max-height="650"
                            column-key
                            highlight-hover-column
                            highlight-hover-row
                            highlightCurrentRow
                            show-header-overflow
                            show-overflow
                            @cell-dblclick="showDetailFun"
                            :sort-config="{multiple: true, trigger: 'cell'}"
                            keep-source
                            :keyboard-config="{isArrow: true}"
                            align="center"
                            :data.sync="PagingGridList"
                            class="mytable-style "
                            ref="refLeftPagingGrid"
                            size="mini">
                        <template v-slot:empty></template>
                        <vxe-table-column field="uid" :title="$t('pubGicSet.LotID')"  align="left"  width="130px" :visible="false"></vxe-table-column>
                        <vxe-table-column field="type" :title="$t('invTrans.transType')" align="left" width="130px" sortable><template v-slot="{row}">{{row.type | filterType}}</template></vxe-table-column>
                        <vxe-table-column field="transactionTime" :title="$t('invTrans.transTime')" align="left"   width="160px" sortable></vxe-table-column>
                        <vxe-table-column field="orderLineNo" :title="$t('invTrans.lineNo')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="docNo" :title="$t('invTrans.orderNo')" width="130px"  align="left" sortable></vxe-table-column>
                        <vxe-table-column field="status" :title="$t('generic.Status')" width="130px"  align="left" sortable></vxe-table-column>
                        <vxe-table-column field="operator" :title="$t('invTrans.operator')" width="130px" align="left" sortable></vxe-table-column>
<!--                        <vxe-table-column field="cubic" :title="$t('pubGicSet.CBM')" width="130px" align="right" sortable></vxe-table-column>-->
<!--                        <vxe-table-column field="gw" :title="$t('pubGicSet.GrossWeight')" width="130px"  align="right" sortable></vxe-table-column>-->
                        <vxe-table-column field="amount" :title="$t('billingMaintance.totalAmount')" width="130px" align="right" sortable></vxe-table-column>
                        <vxe-table-column field="ownerFM" :title="$t('invTrans.ownerCodeFrom')" width="130px" align="left" sortable></vxe-table-column>
                        <vxe-table-column field="skuFM" :title="$t('invTrans.skuFrom')" width="130px"  align="left" sortable></vxe-table-column>
                        <vxe-table-column field="skuDescrFM" :title="$t('invTrans.skuDescFrom')"  align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="lotNoFM" :title="$t('invTrans.lotNoFrom')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="idFM" :title="$t('invTrans.idFrom')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="locFM" :title="$t('invTrans.locFrom')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="qtyFM" :title="$t('invTrans.qtyFrom')" align="right" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="unitQtyFM" :title="$t('invTrans.unitQtyFrom')" align="right" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="uomFM" :title="$t('invTrans.uomFrom')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="toOwner" :title="$t('invTrans.ownerCodeTo')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="toSKU" :title="$t('invTrans.skuTo')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="toSKUDescr" :title="$t('invTrans.skuDescTo')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="lotNoTO" :title="$t('invTrans.lotNoTo')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="idTO" :title="$t('invTrans.idTo')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="locTO" :title="$t('invTrans.locTo')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="toQtyEA" :title="$t('invTrans.unitQtyTo')" align="right" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="toQty" :title="$t('invTrans.qtyTo')" align="right" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="toUOM" :title="$t('invTrans.uomTo')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="descr" :title="$t('batchReceive.Descr')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="productionDate" :title="$t('batchReceive.ManufactureDate')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="expirationDate" :title="$t('batchReceive.ExpiryDate')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="inboundDate" :title="$t('batchReceive.RecDate')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf01" :title="$t('invTrans.lotAttribute')+1" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf02" :title="$t('invTrans.lotAttribute')+ `2`" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf03" :title="$t('invTrans.lotAttribute')+ `3`" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf04" :title="$t('invTrans.lotAttribute')+ `4`" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf05" :title="$t('invTrans.lotAttribute')+ `5`" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf06" :title="$t('invTrans.lotAttribute')+ `6`" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf07" :title="$t('invTrans.lotAttribute')+ `7`" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf08" :title="$t('invTrans.lotAttribute')+ `8`" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf09" :title="$t('invTrans.lotAttribute')+ `9`" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf10" :title="$t('invTrans.lotAttribute')+ `10`" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf11" :title="$t('invTrans.lotAttribute')+ `11`" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="dudf12" :title="$t('invTrans.lotAttribute')+ `12`" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="modifier" :title="$t('generic.Modifier')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="modificationTime" :title="$t('generic.ModifyDate')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="creator" :title="$t('generic.Creator')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="creationTime" :title="$t('generic.CreateDate')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="descriptionTO" :title="$t('invTrans.descriptionFrom')" align="left" width="130px" sortable></vxe-table-column>
                        <vxe-table-column field="descriptionFM" :title="$t('invTrans.descriptionTo')" align="left" width="130px" sortable></vxe-table-column>
                    </vxe-table>
                </a-row>
            </el-card>
        </div>

        <!--弹出明细窗口-->
        <a-modal :title="$t('pubGicSet.Detail')" v-model="showDetail" width="80%" :footer="null" :maskClosable="false">
            <a-form :form="formShow">
                <a-row>
                    <a-col span="24">
                        <el-card class="box-card" style="margin-top: 0px;">
                            <a-row>
                                <a-col :span = "3" offset="0">
                                    <a-form-item class="genericFrom">
                                        <b>{{$t('invTrans.transType')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.type}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span = "3" offset="1">
                                    <a-form-item class="genericFrom">
                                        <b>{{$t('invTrans.lineNo')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.orderLineNo}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span = "3" offset="1">
                                    <a-form-item  class="genericFrom">
                                        <b>{{$t('invTrans.orderNo')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.docNo}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span = "3" offset="0">
                                    <a-form-item class="genericFrom">
                                        <b>{{$t('invTrans.transStatus')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.status}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span = "3" offset="1">
                                    <a-form-item class="genericFrom">
                                        <b>{{$t('invTrans.transTime')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.transactionTime}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span = "3" offset="1">
                                    <a-form-item  class="genericFrom">
                                        <b>{{$t('invTrans.operator')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.operator}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row>
<!--                                <a-col :span = "3" offset="0">-->
<!--                                    <a-form-item class="genericFrom">-->
<!--                                        <b>{{$t('pubGicSet.CBM')}}</b>-->
<!--                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.cubic}]"  :disabled="true"/>-->
<!--                                    </a-form-item>-->
<!--                                </a-col>-->
<!--                                <a-col :span = "3" offset="1">-->
<!--                                    <a-form-item  class="genericFrom">-->
<!--                                        <b>{{$t('pubGicSet.GrossWeight')}}</b>-->
<!--                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.gw}]"  :disabled="true"/>-->
<!--                                    </a-form-item>-->
<!--                                </a-col>-->
                                <a-col :span = "3" offset="1">
                                    <a-form-item  class="genericFrom">
                                        <b>{{$t('invTrans.amount')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.amount}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </el-card>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="11">
                        <el-card class="box-card" style="margin-top: 20px;" :title="$t('easyCron.From')">
                            <a-row style="font-weight: bold;">
                                {{$t('easyCron.From')}}
                            </a-row>
                            <a-row>
                                <a-col :span="6" offset="0">
                                    <a-form-item>
                                        <b>{{$t('batchReceive.SKU')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.skuFM}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" offset="1">
                                    <a-form-item>
                                        <b>{{$t('pubGicSet.SkuDesc')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.skuDescrFM}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" offset="1">
                                    <a-form-item>
                                        <b>{{$t('pubGicSet.Location')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.locFM}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="6">
                                    <a-form-item>
                                        <b>{{$t('invTrans.idFrom')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.idFM}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" offset="1">
                                    <a-form-item>
                                        <b>{{$t('invTrans.uomFrom')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.uomFM}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" offset="1">
                                    <a-form-item>
                                        <b>{{$t('invTrans.qtyFrom')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.qtyFM}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row>
                            </a-row>
                            <a-row>
                                <a-col :span="6" offset="0">
                                    <a-form-item>
                                        <b>{{$t('invTrans.unitQtyFrom')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.unitQtyFM}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </el-card>
                    </a-col>
                    <a-col span="11" offset="2">
                        <el-card class="box-card" style="margin-top: 20px;" :title="$t('easyCron.to')">
                            <a-row style="font-weight: bold;">
                                {{$t('easyCron.to')}}
                            </a-row>
                            <a-row>
                                <a-col :span="6" offset="0">
                                    <a-form-item>
                                        <b>{{$t('batchReceive.SKU')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.toSKU}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" offset="1">
                                    <a-form-item>
                                        <b>{{$t('pubGicSet.SkuDesc')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.toSKUDescr}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" offset="1">
                                    <a-form-item>
                                        <b>{{$t('pubGicSet.Location')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.locTO}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="6">
                                    <a-form-item>
                                        <b>{{$t('invTrans.idTo')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.idTO}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" offset="1">
                                    <a-form-item>
                                        <b>{{$t('invTrans.uomTo')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.toUOM}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" offset="1">
                                    <a-form-item>
                                        <b>{{$t('invTrans.qtyTo')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.toQty}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="6" offset="0">
                                    <a-form-item>
                                        <b>{{$t('invTrans.unitQtyTo')}}</b>
                                        <a-input size="small" v-decorator="['skuFM',{initialValue: this.detailData == null ? '' : this.detailData.toQtyEA}]"  :disabled="true"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </el-card>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>

        <!--SKU查询弹出窗-->
        <search-sku ref="querySkuFromWindow" @checkedSkuCode="checkedSkuCodeFrom"></search-sku>
        <search-sku ref="querySkuToWindow" @checkedSkuCode="checkedSkuCodeTo"></search-sku>

        <!--Location查询弹出窗-->
        <location-info ref="queryLocationFromWindow" @checkedLocationCode="checkedLocationCodeFrom"></location-info>
        <location-info ref="queryLocationToWindow" @checkedLocationCode="checkedLocationCodeTo"></location-info>

        <!--Operator查询弹出窗-->
        <operator ref="queryOperatorWindow" @checkedOperatorCode="checkedOperatorCode"></operator>

        <!--LotId查询弹出窗-->
        <lot-id-info ref="queryLotIdWindow" @checkedLotId="checkedLotId"></lot-id-info>

    </div>
</template>

<script>
    import { mapState } from "vuex";
    import ajax from "../../api/ajax";
    import api from "../../api/url";
    import searchSku from "./components/searchSku";
    import locationInfo from "./components/locationInfo";
    import operator from "./components/operator";
    import lotIdInfo from "./components/lotIdInfo";
    import moment from "moment";

    let that;
    export default{
        components: {
            searchSku,
            locationInfo,
            operator,
            lotIdInfo,
        },
        data(){
            return{
                showQuery:true,//是否显示查询条件界面
                showList:false,//是否显示查询列表界面
                showDetail:false,//是否显示明细弹出窗
                pagingTotal: 0, // 总数
                pagingSize: 20, // 条数
                currentVal: 1, // 当前选中的页数
                showSizeChanger:true,//是否显示页码下拉框
                showQuickJumper:false,//是否显示快速跳转输入框
                pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                PagingGridList: [],//列表数据
                formQuery: this.$form.createForm(this, {}),
                formShow: this.$form.createForm(this, {}),
                detailData:null,
                typeGroup:[],//Type下拉框
                batchAttributes:[],//批次属性
                sysTranmgtDayrange:null,
            }
        },

        computed: {
            ...mapState(["systemParam"]),
        },

        created() {
            this.initUdf();
            this.initDataCodeGroup();
            that = this;
        },
        filters: {
            filterType(val) {
                let sta = that.typeGroup;
                for(let i in sta){
                    if(val.toLowerCase() == sta[i].CODE.toLowerCase()){
                        return sta[i].CODE_DESC
                    }
                }
            }
        },
        methods:{
            moment,
            initUdf(){//获取自定义批次属性
                ajax.post(api.PROJECTUSERDEFINEDFILEDINFO,null).then(res=>{
                    if(res.code == 200){
                        this.batchAttributes = res.data;
                    }
                })
            },
            initDataCodeGroup(){
                let params = {//配置查询条件
                    groupCode : "TRAN_TYPE"
                }
                ajax.get(api.FINDDATABYCODEGROUP,params).then(res=>{
                    if(res.code == 200){
                        this.typeGroup = res.data;
                    }
                })
            },
            query(){
                this.formQuery.validateFields((err, values) => {
                    if(err){
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
                        return;
                    }
                    if(values){
                        values["currentVal"] = this.currentVal;
                        values["pagingSize"] = this.pagingSize;
                        if((values.lotId == undefined || values.lotId == '') &&
                            (values.orderNo == undefined || values.orderNo == '') &&
                            (values.tranTimeFM == undefined || values.tranTimeFM == '') &&
                            (values.tranTimeTO == undefined || values.tranTimeTO == '') &&
                            (values.operator == undefined || values.operator == '') &&
                            (values.skuFrom == undefined || values.skuFrom == '') &&
                            (values.locationFrom == undefined || values.locationFrom == '') &&
                            (values.idFrom == undefined || values.idFrom == '') &&
                            (values.skuTo == undefined || values.skuTo == '') &&
                            (values.locationTo == undefined || values.locationTo == '') &&
                            (values.idTo == undefined || values.idTo == '') &&
                            (values.manufactureDate == undefined || values.manufactureDate == '') &&
                            (values.expiryDate == undefined || values.expiryDate == '') &&
                            (values.recDate == undefined || values.recDate == '')
                        ){
                            if(values.type == undefined || values.type == ''){
                                this.$customMessage.warning(this.$t('publicLang.PleaseOneLeast'), 2);
                                return;
                            }else{
                                this.$customMessage.warning(this.$t('invTrans.pleaseSelectAQueryPeriod'), 2);
                                return;
                            }
                        }
                        //type必选
                        if(values.type == undefined || values.type == ''){
                            this.$customMessage.warning(this.$t('invTrans.typeMustBeSelected'), 2);
                            return;
                        }
						// Tom 2023-09-13  当FROM_TIME，TO_TIME为空时验证Type必填
	                    if((values.type == undefined || values.type == '') &&
	                        (values.tranTimeFM == undefined || values.tranTimeFM == '') &&
	                        (values.tranTimeTO == undefined || values.tranTimeTO == '') ) {
	                        this.$customMessage.warning(this.$t('publicLang.PleaseOneLeast'), 2);
	                        return;
	                    }
                        if((values.tranTimeFM != undefined && values.tranTimeFM != '') && (values.tranTimeTO != undefined && values.tranTimeTO != '')){
                            this.sysTranmgtDayrange =  this.systemParam.SYS_TRANMGT_DAYRANGE;
                            if(parseInt((values.tranTimeTO - values.tranTimeFM)/1000/60/60/24) > this.sysTranmgtDayrange){
                                this.$customMessage.warning(this.$t('invTrans.transactionTime', {"0":this.sysTranmgtDayrange}), 2);
                                return;
                            }
                        }
                        this.showQuery = false;
                        this.showList = true;
                        ajax.post(api.GETTRANSACTIONLOG,values).then(res=>{
                            if(res.code == 200){
                                this.PagingGridList = res.data;//列表
                                this.pagingTotal = res.total;//总数
                            }
                        })
                    }
                });
            },
            reset(){
                this.formQuery = this.$form.createForm(this, {});
            },
            exportInvTranLog(){
                this.formQuery.validateFields((err, values) => {
                    if(err){
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
                        return;
                    }
                    if(values){
                        values["currentVal"] = this.currentVal;
                        values["pagingSize"] = this.pagingSize;
                        if((values.tranTimeFM != undefined && values.tranTimeFM != '') && (values.tranTimeTO != undefined && values.tranTimeTO != '')){
                            this.sysTranmgtDayrange =  this.systemParam.SYS_TRANMGT_DAYRANGE;
                            if(parseInt((values.tranTimeTO - values.tranTimeFM)/1000/60/60/24) > this.sysTranmgtDayrange){
                                this.$customMessage.warning(this.$t('invTrans.transactionTime', {"0":this.sysTranmgtDayrange}), 2);
                                return;
                            }
                        }
                        let ajaxurl = ajax.ajaxUrl();
                        let that = this
                        ajax.exportExcel(ajaxurl + api.EXPORTINVTRANLOG, values).then(data=>{
                            this.$store.commit("updataLoading", { pbLoading: false });
                            if (!data) {
                                return;
                            }
                            var blob = new Blob([data.data], {
                                type:
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                            });
                            var url = window.URL.createObjectURL(blob);
                            var aLink = document.createElement("a");
                            aLink.style.display = "none";
                            aLink.href = url;
                            aLink.setAttribute("download", "InvTranLog.xlsx");
                            document.body.appendChild(aLink);
                            aLink.click();
                            document.body.removeChild(aLink); //下载完成移除元素
                            window.URL.revokeObjectURL(url); //释放掉blob对象
                        })
                    }
                });
            },
            back(){
                this.showQuery = true;
                this.showList = false;
            },
            tableChangePage(current) {
                this.currentVal = current;
                this.query();
            },
            onShowSizeChange(current, pageSize) {//选择下拉框后触发事件
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.query();
            },
            showDetailFun({ row }) {//双击弹出明细窗口
                this.showDetail = true;
                this.detailData = row;
                // row.qtyFM = parseFloat(this.detailData.qtyFM).toFixed(2);
            },
            skuFromSearch(){
                this.$refs.querySkuFromWindow.show(this.formQuery.getFieldValue('skuFrom') == null ? '' : this.formQuery.getFieldValue('skuFrom'))
            },
            skuToSearch(){
                this.$refs.querySkuToWindow.show(this.formQuery.getFieldValue('skuTo') == null ? '' : this.formQuery.getFieldValue('skuTo'))
            },
            locationFromSearch(){
                this.$refs.queryLocationFromWindow.show(this.formQuery.getFieldValue('locationFrom') == null ? '' : this.formQuery.getFieldValue('locationFrom'))
            },
            locationToSearch(){
                this.$refs.queryLocationToWindow.show(this.formQuery.getFieldValue('locationTo') == null ? '' : this.formQuery.getFieldValue('locationTo'))
            },
            operatorSearch(){
                this.$refs.queryOperatorWindow.show(this.formQuery.getFieldValue('operator') == null ? '' : this.formQuery.getFieldValue('operator'))
            },
            lotIdSearch(){
                this.$refs.queryLotIdWindow.show(this.formQuery.getFieldValue('lotId') == null ? '' : this.formQuery.getFieldValue('lotId'))
            },
            checkedSkuCodeFrom(val) {
                this.formQuery.setFieldsValue({
                    skuFrom: val
                })
            },
            checkedSkuCodeTo(val) {
                this.formQuery.setFieldsValue({
                    skuTo: val
                })
            },
            checkedLocationCodeFrom(val) {
                this.formQuery.setFieldsValue({
                    locationFrom: val
                })
            },
            checkedLocationCodeTo(val) {
                this.formQuery.setFieldsValue({
                    locationTo: val
                })
            },
            checkedOperatorCode(val) {
                this.formQuery.setFieldsValue({
                    operator: val
                })
            },
            checkedLotId(val) {
                this.formQuery.setFieldsValue({
                    lotId: val
                })
            },
        }
    }
</script>

<style scoped>
    .mains{
        padding: 10px;
        height: 100%;
        width: 100%;
        background-color: white;
        float: left;
    }
    .position{
        text-align: left;
    }
</style>